module.exports = __webpack_public_path__ + "img/p-4.c954963d.jpg";